<template>
  <!-- Utilizamos v-show y no input-value como propone la documentacion de vuetify ya que no funciona de la forma deseada-->
  <v-bottom-navigation class="ca-bottom-nav" v-show="show" app>
    <!--
      Espacio izquierda: Condicional según estado de props y la siguiente prioridad:
        1. Si hay un error se muestra
        2. Si no hay error y hay cambios sin guardar (prop alert_cambios) se muestra mensaje de cambios sin guardar.
        3. Si no es ninguna de las otras dos, se recurre a slot "slot-izquierda" (condicional)
    -->
    <v-alert class="ca-alert" v-if="hayError" type="error" transition="scale-transition">
      {{error}}
    </v-alert>
    <div class="ca-bottomNav-cambios" v-else-if="cambios_pendientes">
      <v-icon class="ca-bottomNav-cambios-icon" color="warning">
        report
      </v-icon>
      <div class="ca-bottomNav-cambios-label">
        Cambios sin guardar
      </div>
    </div>
    <slot name="slot-izquierda" v-else></slot>

    <v-spacer></v-spacer>

    <!--
      Slot default: Botones de la derecha
    -->
    <slot></slot>
  </v-bottom-navigation>
</template>

<script>
/*
    Componente base utilizado desde las distintas páginas de consorcio, renderiza una barra de navegación en la parte
      inferior de la aplicación (se muestra por encima del footer), usualmente con botones que brindan acciones relativas
      a la página en la que se encuentra el usuario en el sector derecho de la barra (slot default)

    Adicionalmente, el componente ofrece la posibilidad de pasar mensaje de error que muestra con alerta rojo en la izquierda,
      alerta izquierda con mensaje de cambios sin guardar (común a varias pantallas de CA), y un slot para posicionar cualquier cosa
      en esa misma posición (se renderiza un item de estos 3 a la vez, con prioridad tal cual fueron nombrados).
  */
export default {
  props: {
    show: {type: Boolean, default: true},
    cambios_pendientes: {type: Boolean, default: false},
    error: {type: String, default: ''}
  },
  computed: {
    hayError() {
      return !!this.error;
    }
  }
};
</script>

<style lang="scss">
  .v-bottom-navigation.ca-bottom-nav {
    height: $bottom-nav-height;
    background-color: color(secondary);
    opacity: 1;
    width: 100%;
    padding: 0 20px; // Padding izquierdo redefinido por computed property paddingIzquierda
    display: flex;
    align-items: center;
    .v-btn:not(.v-btn--round).v-size--default {
      opacity: 1;
      text-transform: uppercase;
      filter: none;
      margin-left: 10px;
      height: 36px;
      min-width: 110px;
      max-width: unset;
      width: fit-content;
      flex-grow: 0;
      color: color(blanco) !important;

      border-radius: 2px;
      .v-btn__content {
        font-weight: 500;
        font-size: 14px;
        opacity: 1;
      }
      &.btn--flat {
        background-color: color(gris-oscuro);
      }
      &.btn--ppal {
        background-color: color(accent);
      }
      &.btn--rojo {
        background-color: color(rojo);
      }
    }
    > * {
      flex: unset;
    }
    .ca-alert {
      flex-grow: 0;
    }
    .ca-bottomNav-cambios {
      color: color(warning);
      display: flex;
      align-items: center;
    }
    .ca-bottomNav-cambios-icon {
      font-size: 30px;
      margin-right: 10px;
    }
    .ca-bottomNav-cambios-label {
      font-size: 16px;
    }
  }
</style>
